/**
 * Arrival Checklist
 * Berthing and securing alongside
 * Regulatory: Company SMS
 */

export const ARRIVAL_CHECKLIST = {
  id: 'arrival',
  name: 'Arrival',
  description: 'Berthing and securing alongside',
  icon: 'Ship',
  regulatory: 'Company SMS',
  isCustomisable: true,
  items: [
    { id: 'arr_1', text: 'Vessel secured alongside/at anchor', required: true },
    { id: 'arr_2', text: 'Gangway rigged (if applicable)', required: false },
    { id: 'arr_3', text: 'Shore power connected (if required)', required: false },
    { id: 'arr_4', text: 'Arrival fuel level recorded', required: true },
    { id: 'arr_5', text: 'Arrival time and position logged', required: true },
    { id: 'arr_6', text: 'Port authority/agent notified of arrival', required: false }
  ]
};
